import "./TradeListingStats.css";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { simplifyTradingVolume } from "../../../../helpers/helper";

const toFiniteNumber = (value) => {
  if (typeof value === "string") {
    const cleaned = value.replace(/[$,%\s,]/g, "");
    const num = Number(cleaned);
    return Number.isFinite(num) ? num : 0;
  }
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

const getToneClass = (value) => {
  const num = toFiniteNumber(value);
  if (num > 0) return "is-positive";
  if (num < 0) return "is-negative";
  return "is-neutral";
};

const formatPercent = (value) => {
  const num = toFiniteNumber(value);
  return `${num.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}%`;
};

const TradeListingStats = ({ renderTradeCalender }) => {
  const api = useApi();
  const user = useSelector((state) => state?.user?.user);
  const [dailyAvgProfit, setDailyAvgProfit] = useState(0);
  const [avgTradeRoi, setAvgTradeRoi] = useState(0);
  const [winRate, setWinRate] = useState(0);
  const [groupTradingVolume, setGroupTradingVolume] = useState("0");

  useEffect(() => {
    const fetchStats = async () => {
      if (!user?._id) return;
      const response = await api(
        "get",
        `multiCommunity/getCurrentStats/${user._id}`
      );
      if (response?.status && response.data) {
        setDailyAvgProfit(simplifyTradingVolume(response.data.dailyAvgProfit));
        setGroupTradingVolume(
          simplifyTradingVolume(response.data.groupTradingVolume)
        );
        let nextAvgTradeRoi = simplifyTradingVolume(
          response.data.avgTradeRoi || 0
        );
        nextAvgTradeRoi =
          typeof nextAvgTradeRoi === "string"
            ? nextAvgTradeRoi
            : nextAvgTradeRoi.toFixed(2);
        setAvgTradeRoi(nextAvgTradeRoi);
        setWinRate(simplifyTradingVolume(response.data.winRate));
      }
    };
    fetchStats();
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      if (!user?._id) return;
      const response = await api(
        "post",
        "multiCommunity/getSpecificUserStats",
        {
          userIds: [user._id],
        }
      );
      if (response?.status && response.data) {
        setDailyAvgProfit(simplifyTradingVolume(response.data.dailyAvgProfit));
        let nextAvgTradeRoi = simplifyTradingVolume(
          response.data.avgTradeRoi || 0
        );
        nextAvgTradeRoi =
          typeof nextAvgTradeRoi === "string"
            ? nextAvgTradeRoi
            : nextAvgTradeRoi.toFixed(2);
        setAvgTradeRoi(nextAvgTradeRoi);
        setWinRate(simplifyTradingVolume(response.data.winRate));
        setGroupTradingVolume(
          simplifyTradingVolume(response.data.groupTradingVolume)
        );
      }
    };
    fetchStats();
  }, [user]);

  const volumeLabel =
    user?.leaderCommunity || (user?.leaderCommunity && user?.tradeName)
      ? "Group Trading Volume"
      : "Trading Volume";

  const stats = [
    {
      key: "daily",
      title: "Daily Avg. Profit",
      value: formatPercent(dailyAvgProfit),
      tone: getToneClass(dailyAvgProfit),
    },
    {
      key: "roi",
      title: "Avg. Trade ROI",
      value: formatPercent(avgTradeRoi),
      tone: getToneClass(avgTradeRoi),
    },
    {
      key: "win",
      title: "Avg. Win Rate",
      value: formatPercent(winRate),
      tone: getToneClass(winRate),
    },
    {
      key: "volume",
      title: volumeLabel,
      value: `$${groupTradingVolume || 0}`,
      tone: "is-neutral",
    },
  ];

  return (
    <div
      className={`tradeListingStatBox ${
        renderTradeCalender ? "verifiedTradeListingStatBox" : ""
      }`}
    >
      <div className="rowGrid m-0">
        {stats.map((item) => (
          <div key={item.key} className="gridItem p-md-0">
            <div className="statItem">
              <p className="title">{item.title}</p>
              <p className={`statNumber ${item.tone}`}>{item.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TradeListingStats;
